// Copyright (c) 2016 Deere & Company

import {buildEndpoint} from './end-point';
import {fetch as deereFetch} from '@deere/cps-it.fetch-wrapper';
import {getStore} from '../../store-factory';
import {oktaToken} from './okta';

/* eslint-disable complexity */

export async function fetch(input, options = {}) {

    const state = getStore().getState();

    const endPoint = buildEndpoint(input, options, state.app.sapStatus.isSapUp, state.appConfig.cloud, state.user.entitlements, state.user.details.id);

    if (endPoint === null) {

        // if endpoint is null it is because the endpoint is currently unavailable and we should return the predetermined error code for proper handling

        throw new Response(null, {status: 553, url: input});

    } else {

        const language = state.user.details.settings.language.primaryLanguage.key.length ?
            state.user.details.settings.language.primaryLanguage.key :
            'EN';

        const selectedSapEnvironment = state.appConfig.sapEnvironments.length > 0 ?
            state.appConfig.sapEnvironments.find(environment => environment.defaultVal).name :
            '';

        const accessToken = await oktaToken('accessToken');

        if (typeof accessToken === 'undefined') {

            /* eslint-disable no-throw-literal */

            throw 'no token available';

            /* eslint-enable no-throw-literal */

        }

        const conditionalHeaders = {
            'Content-Type': 'application/json'
        };

        /* for some types of requests, content-type header must not be set as it will override default behavior.
        To remove, include allowAutomaticContentType=true in options when making the call */

        if (options.hasOwnProperty('allowAutomaticContentType')) {

            Reflect.deleteProperty(conditionalHeaders, 'Content-Type');
            Reflect.deleteProperty(options, 'allowAutomaticContentType');

        }

        const fetchOptions = {
            headers: {
                'Accept-Language': language,
                Authorization: accessToken ? `Bearer ${accessToken.accessToken}` : '',
                sapEnvironment: selectedSapEnvironment,
                ...conditionalHeaders
            },
            ...options
        };

        return deereFetch(endPoint, fetchOptions);

    }

}

/* eslint-enable complexity */

export function anonFetch(input, options) {

    return deereFetch(input, options);

}



// WEBPACK FOOTER //
// ./src/shared/services/fetch.js